/** @file Factory for `<domain>.delete` commands: resolves the target and cascades via removeEntity. */
import { z } from 'zod';
import { removeEntity } from '@pose2d/format/doc/removeEntity';
import type { EntityKind } from '@pose2d/format/types';
import { defineCommand, type CommandDef } from '../defineCommand';

/** Builds a remove command for `kind`. */
export function defineRemove(spec: { domain: string; kind: EntityKind; description: string }): CommandDef<{ target: string }> {
  return defineCommand({
    name: `${spec.domain}.delete`,
    description: spec.description,
    input: z.object({ target: z.string().min(1) }).strict(),
    apply(draft, input, ctx) {
      const id = ctx.resolve(spec.kind, input.target);
      const cascaded = removeEntity(draft, spec.kind, id).filter((removed) => removed !== id);
      if (cascaded.length > 0) {
        ctx.warnings.push({ code: 'INFO', message: `also removed ${cascaded.length} dependent entities`, params: { count: cascaded.length, ids: cascaded.join(',') }, path: 'target' });
      }
      draft.meta.updatedAt = ctx.now;
    },
  });
}
